import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconResizeLarge$1 = /*@__PURE__*/ proxyCustomElement(class WppIconResizeLarge extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-resize-large", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M5.52778 4.16667C4.77606 4.16667 4.16667 4.77606 4.16667 5.52778V6.69444C4.16667 7.01661 3.9055 7.27778 3.58333 7.27778C3.26117 7.27778 3 7.01661 3 6.69444V5.52778C3 4.13172 4.13172 3 5.52778 3H6.69444C7.01661 3 7.27778 3.26117 7.27778 3.58333C7.27778 3.9055 7.01661 4.16667 6.69444 4.16667H5.52778ZM15.8333 5.52778C15.8333 4.77606 15.2239 4.16667 14.4722 4.16667H13.3056C12.9834 4.16667 12.7222 3.9055 12.7222 3.58333C12.7222 3.26117 12.9834 3 13.3056 3H14.4722C15.8683 3 17 4.13172 17 5.52778V6.69444C17 7.01661 16.7388 7.27778 16.4167 7.27778C16.0945 7.27778 15.8333 7.01661 15.8333 6.69444V5.52778ZM15.8333 14.4722C15.8333 15.2239 15.2239 15.8333 14.4722 15.8333H13.3056C12.9834 15.8333 12.7222 16.0945 12.7222 16.4167C12.7222 16.7388 12.9834 17 13.3056 17H14.4722C15.8683 17 17 15.8683 17 14.4722V13.3056C17 12.9834 16.7388 12.7222 16.4167 12.7222C16.0945 12.7222 15.8333 12.9834 15.8333 13.3056V14.4722ZM4.16667 14.4722C4.16667 15.2239 4.77606 15.8333 5.52778 15.8333H6.69444C7.01661 15.8333 7.27778 16.0945 7.27778 16.4167C7.27778 16.7388 7.01661 17 6.69444 17H5.52778C4.13172 17 3 15.8683 3 14.4722V13.3056C3 12.9834 3.26117 12.7222 3.58333 12.7222C3.9055 12.7222 4.16667 12.9834 4.16667 13.3056V14.4722ZM7.08338 5.33333C6.11688 5.33333 5.33338 6.11684 5.33338 7.08333V12.9165C5.33338 13.883 6.11688 14.6665 7.08338 14.6665H12.9166C13.8831 14.6665 14.6666 13.883 14.6666 12.9165V7.08333C14.6666 6.11684 13.8831 5.33333 12.9166 5.33333H7.08338ZM6.50005 7.08333C6.50005 6.76117 6.76121 6.5 7.08338 6.5H12.9166C13.2387 6.5 13.4999 6.76117 13.4999 7.08333V12.9165C13.4999 13.2387 13.2387 13.4999 12.9166 13.4999H7.08338C6.76121 13.4999 6.50005 13.2387 6.50005 12.9165V7.08333Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-resize-large-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-resize-large", "wpp-icon-resize-large-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-resize-large-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-resize-large-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconResizeLarge$1);
      }
      break;
  } });
}

const WppIconResizeLarge = WppIconResizeLarge$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconResizeLarge, defineCustomElement };
